var storesPath = '/product-page/';
var bookingsPath = '/bookings-checkout/';
var eventsPath = '/event-details/';
var UNIVERSAL_DELIMITER = '?d=';
var UNIVERSAL_REGEX = /^https:\/\/www.wix.app/;
var getWebUrlFromUniversalUrl = function (url) { return url.split(UNIVERSAL_DELIMITER)[1]; };
var getVerticalRelativePath = function (webUrl) {
    var position = Math.max(webUrl.indexOf(storesPath), webUrl.indexOf(bookingsPath), webUrl.indexOf(eventsPath));
    return webUrl.slice(position);
};
var removeLastSlashFromUrl = function (url) { return url.replace(/\/$/, ''); };
var replaceWebUrlInsideUniversalUrl = function (universalUrl, webUrl) {
    var base = universalUrl.split(UNIVERSAL_DELIMITER)[0];
    return "".concat(base).concat(UNIVERSAL_DELIMITER).concat(webUrl);
};
export var changeBaseUrl = function (url, baseUrl) {
    var isUniversalUrl = url.match(UNIVERSAL_REGEX);
    var oldWebUrl = isUniversalUrl ? getWebUrlFromUniversalUrl(url) : url;
    var path = getVerticalRelativePath(oldWebUrl);
    var webUrl = removeLastSlashFromUrl(baseUrl) + path;
    return isUniversalUrl ? replaceWebUrlInsideUniversalUrl(url, webUrl) : webUrl;
};
//# sourceMappingURL=changeBaseUrl.js.map